export function LivewireSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/livewire.svg'"></ng-include>`
    }
}